<div *ngIf="showLoader" id="loader-div">
    <span id="loader">
        <span></span>
        <span></span>
    </span>
</div>